<template>
   <div>
      <button id="notificationBtn" data-bs-target="#notification" data-bs-toggle="modal" style="display: none" />
      <div
         id="notification"
         aria-hidden="true"
         aria-labelledby="notification"
         class="modal fade modal-custom"
         role="dialog"
         tabindex="-1"
      >
         <div class="modal-dialog" role="document">
            <div class="modal-custom__content">
               <span class="modal-custom__action" data-bs-dismiss="modal">
                  <i class="icon-fonts icon-fonts--close"></i>
               </span>
               <div class="modal-custom__body">
                  <div class="modal-custom__images">
                     <img :src="showedData.icon" alt="img" />
                  </div>
                  <h3 class="modal-custom__title">{{ showedData.title }}</h3>
                  <p v-if="showedData.content" class="modal-custom__des" v-html="showedData.content"></p>
                  <div class="modal-custom__btn modal-custom__btn--full">
                     <button class="button button--primary" data-bs-dismiss="modal" @click="onClose">
                        {{ showedData.closeButton }}
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
import $ from 'jquery'
import i18n from '@/plugins/i18n'

export default {
   name: 'notification-modal',
   props: {
      data: Object, // Type: {title: "", icon: "", content: "", closeButton: ""}
      onClose: {
         type: Function,
         default: () => {}
      }
   },
   data() {
      return {
         showedData: {}
      }
   },
   watch: {
      data() {
         this.showedData = {
            title: this.data.title ?? i18n.t('notification.title'),
            icon: this.data.icon ?? './images/ic-warning.svg',
            content: this.data.content ?? i18n.t('notification.not_connect_to_server'),
            closeButton: this.data.cancelButton ?? i18n.t('buttons.close')
         }
         $('#notificationBtn').trigger('click')
      }
   }
}
</script>

<style lang="scss" scoped>
.modal-custom {
   &__content {
      position: relative;
      padding: 30px 25px;
   }

   &__action {
      position: absolute;
      top: 20px;
      right: 20px;
      height: 20px;
      width: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--bs-primary);
      border-radius: 50%;
      padding: 0;

      i {
         color: var(--bs-white);
         font-size: 15px;
         font-weight: bolder;
      }
   }

   &__images {
      margin-bottom: 15px;
      width: 60px;
      height: 60px;
   }

   &__title {
      font-size: 17px;
      color: #000000;
      font-weight: bold;
      margin-bottom: 10px;
   }

   &___des {
      font-size: 13px;
      color: #5a5a5a;
      margin: 10px 0 20px;
   }

   &__btn {
      margin: 0;

      .button {
         max-width: 200px;
         border-radius: 100px;
         height: 44px;
      }
   }
}
</style>
